export const localStorageToken = localStorage.getItem("__extraconomy_token");

export const removelocalStorageToken = () => localStorage.removeItem("__extraconomy_token");
